import { UserRoleEnums } from "utils/Constant";

const {  RECEPTIONIST, DATA_CLERK,SENIOR_MOLECULAR_BIOLOGIST,PRINICPAL_INVESTIGATOR } =
  UserRoleEnums;

export const espnFieldItems = [
  {
    key: "espn/moore-swab-deployment",
    id: "espn.mooreSwabDeploymentRecords",
    base: "moore-swab-deployment",
    icon: "DeploymentUnitOutlined",
    roles: [PRINICPAL_INVESTIGATOR,SENIOR_MOLECULAR_BIOLOGIST, RECEPTIONIST, DATA_CLERK],
  },
  {
    key: "espn/sample-collection",
    id: "espn.sampleCollectionRecords",
    base: "sample-collection",
    icon: "ProfileOutlined",
    roles: [PRINICPAL_INVESTIGATOR,SENIOR_MOLECULAR_BIOLOGIST, RECEPTIONIST, DATA_CLERK],
  },
  {
    key: "espn/incidence-reporting",
    id: "espn.incidenceReportingRecords",
    base: "incidence-reporting",
    icon: "FileTextOutlined",
    roles: [PRINICPAL_INVESTIGATOR,SENIOR_MOLECULAR_BIOLOGIST, RECEPTIONIST, DATA_CLERK],
  },
  {
    key: "espn/sample-submission",
    id: "espn.sampleSubmissionRecords",
    base: "sample-submission",
    icon: "UploadOutlined",
    roles: [PRINICPAL_INVESTIGATOR,SENIOR_MOLECULAR_BIOLOGIST, RECEPTIONIST, DATA_CLERK],
  },
  {
    key: "espn/sample-collection-supervision",
    id: "espn.sampleCollectionSupervisionRecords",
    base: "sample-collection-supervision",
    icon: "EyeOutlined",
    roles: [PRINICPAL_INVESTIGATOR,SENIOR_MOLECULAR_BIOLOGIST],
  },
];

export default espnFieldItems;